import React from 'react';
import Script from 'next/script';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

export type ScriptObject = {
  isJson?: string;
  id: string;
  url?: string;
  urlPrv?: string;
  code?: string;
  codePrv?: string;
  lazyLoad: string;
};

type ScriptTagsProps = {
  beforeInteractiveFlag?: boolean;
  scripts?: ScriptObject[];
};

const ScriptTags = (props: ScriptTagsProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isPreview = sitecoreContext.route?.databaseName === 'preview';
  return (
    <>
      {props.scripts?.map((scr: ScriptObject) => {
        const code = isPreview ? scr.codePrv : scr.code;
        const url = isPreview ? scr.urlPrv : scr.url;
        if (scr.id) {
          return (
            <Script
              type={scr.isJson === '1' ? 'application/ld+json' : 'text/javascript'}
              src={code ? undefined : url}
              key={scr.id}
              id={scr.id}
              defer={scr.lazyLoad === '1'}
              dangerouslySetInnerHTML={{ __html: code || '' }}
              strategy={props.beforeInteractiveFlag ? 'beforeInteractive' : 'afterInteractive'}
            ></Script>
          );
        } else {
          return <></>;
        }
      })}
    </>
  );
};

export default ScriptTags;
